import { makeStyles } from "@mui/styles";
const colors = {
    error: "#FF6E6E",
    info: "#2F47B2",
    "info-gray": "#707070",
    warning: "#FBC02D",
};
export const useStyles = makeStyles(() => ({
    arrow: ({ variant }) => ({
        color: colors[variant],
    }),
    popper: ({ maxWidth }) => ({
        maxWidth: maxWidth,
    }),
    tooltip: ({ variant, size }) => ({
        background: colors[variant],
        color: "#ffffff",
        fontSize: {
            big: "14px",
            small: "10px",
        }[size],
        fontWeight: "normal",
        lineHeight: {
            big: "16px",
            small: 1.5,
        }[size],
        padding: {
            big: 6,
            small: "5px 10px",
        }[size],
    }),
}));
//# sourceMappingURL=ui_tooltip.css.js.map